export enum NfcScanType {
  Building = "Building",
  Machine = "Machine",
}
